import { useCallback } from 'react';
import { useNavigation } from '../function/navigation';
import {
  productSizeCheck,
  renderProductCheck,
} from '../function/CheckProductReady';
import { handleRedirect } from '../function/handleRedirect';

export function ProductSize({ inputs, setInputs, result, clickTriggeredRef }) {
  const { dispatch } = useNavigation();
  const setProductTab = useCallback(
    (tab) => dispatch({ type: 'productCurrentPage', payload: { tab: tab } }),
    [dispatch]
  );
  const setCurrentPage = useCallback(
    (page) => dispatch({ type: 'currentPage', payload: page }),
    [dispatch]
  );

  const isProduct = inputs.product_tbh?.length > 0;
  const productTestClassName = !isProduct
    ? 'item-missing'
    : productSizeCheck(isProduct, result)
      ? 'checked'
      : 'not-checked';

  return (
    <ul className="group">
      <li>
        <div className={`result-name ${productTestClassName}`}>
          {isProduct ? 'Product check' : 'No product tested'}
        </div>
        {isProduct ? (
          renderProductCheck(isProduct, result, inputs.unit_system)
        ) : (
          <button
            className="button-sm button-primary"
            onClick={() =>
              handleRedirect(
                'add-product',
                dispatch,
                setInputs,
                setProductTab,
                setCurrentPage,
                clickTriggeredRef
              )
            }
          >
            Add a product
          </button>
        )}
      </li>
    </ul>
  );
}
